module.exports = __webpack_public_path__ + "img/clipboard.47f6c417.png";